import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AdditionalCriteriaType, Action } from "app/pages/DiscountEditor/actionTypes";
import { Modal, Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { deleteAdditionalCriteria, setDeleteCriteriaConfirmationModal } from 'app/pages/DiscountEditor/actions';
import { getDeleteConfirmationModal } from 'app/pages/DiscountEditor/modules/AdditionalCriteria';

type InternalProps = StateProps & DispatchProps; 

interface StateProps {
    isOpen: boolean, 
    additionalCritieriaType: AdditionalCriteriaType
}

interface DispatchProps {
    onCancel: () => void, 
    onDelete: (type: AdditionalCriteriaType) => void
}

const DeleteCriteriaConfirmationModal = (props: InternalProps) => (
    <Modal 
           open={props.isOpen} 
           onCancel={props.onCancel}
           title="Delete additional criteria"
           footer={[
               <Button key="cancel" onClick={props.onCancel}>Cancel</Button>,
               <Button key="delete" danger icon={<DeleteOutlined />} onClick={() => props.onDelete(props.additionalCritieriaType)}>Delete</Button>
           ]}>
      Are you sure you want to delete this additional criteria? 
    </Modal>
  )

const mapStateToProps = (state:any, ownProps: {}) : StateProps => {
    const critieriaType = getDeleteConfirmationModal(state); 

    return { 
      isOpen: critieriaType !== AdditionalCriteriaType.None, 
      additionalCritieriaType: critieriaType
    };
}
  
const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>) : DispatchProps => {
    return {
      onCancel: () => dispatch(setDeleteCriteriaConfirmationModal(AdditionalCriteriaType.None)), 
      onDelete: (type: AdditionalCriteriaType) => dispatch(deleteAdditionalCriteria(type))      
    }; 
}
  
export default connect(mapStateToProps, mapDispatchToProps)(DeleteCriteriaConfirmationModal);